import {RootState} from '@/store'
import {UserDetailsResponse} from '@payroll/optimus-common'
import {Module} from 'vuex'
import {actions} from './actions'
import {getters} from './getters'
import {mutations} from './mutations'

export interface AuthenticationState {
  obfuscatedPhoneNum: string
  obfuscatedEmail: string
  userDetails: UserDetailsResponse
  customerDetails: any
  mngCompanyName: string,
  authorizedPages: string[],
  idNumber: string,
  oprEntityKey: number,
  clientErrorIndication: boolean
}

export const initialState = function (): AuthenticationState {
    return {
      obfuscatedPhoneNum: '',
      obfuscatedEmail: '',
      userDetails: {} as UserDetailsResponse,
      customerDetails: {},
      mngCompanyName: '',
      authorizedPages: [],
      idNumber: '',
      oprEntityKey: 0,
      clientErrorIndication: false
    }
}

export const authentication: Module<AuthenticationState, RootState> = {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}